import { Meta, metaFromResponse } from '../Meta/Meta';

export interface Blog {
  id: number;
  title: string;
  slug: string;
  shortDescription: string;
  description: string;
  meta: Meta;
  coverImage: string;
  createdAt: Date;
  updatedAt: Date;
}

export const blogFromResponse = (responseData: any): Blog => ({
  id: responseData.id,
  title: responseData.title,
  slug: responseData.slug,
  shortDescription: responseData.short_description,
  description: responseData.description,
  meta: metaFromResponse(responseData.meta),
  coverImage: responseData.cover_image,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});
